import React from 'react'
import PropTypes from 'prop-types'
import { RadioBox, Flex, Spacer } from '@jisr-hr/design-system'
import { Typography } from '@jisr-hr/ds'

const Group = ({
  label,
  options,
  meta: { touched, error },
  input: { onChange, value },
  handleOnChange,
  labelKey,
  valueKey,
}) => (
  <div>
    {label && (
      <>
        <Typography
          text={` ${label}`}
          variant="subtitle-2"
        />
        <Spacer height={4} />
      </>
    )}
    <Flex style={{ gap: 8 }}>
      {options?.map((option) => (
        <RadioBox
          key={`radio-${option.value}`}
          onChange={(v) => {
            onChange(v)
            handleOnChange?.(v)
          }}
          data-testid={option[valueKey]}
          value={option[valueKey]}
          checked={value === option[valueKey]}
          label={option[labelKey]}
          variant="simple"
        />
      ))}
    </Flex>
    {touched && error && (
      <Typography
        text={error}
        variant="subtitle-2"
        textColor="color/fg/danger/bold"
      />
    )}
  </div>
)

Group.propTypes = {
  input: PropTypes.shape(),
  meta: PropTypes.shape(),
  handleOnChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape()),
  labelKey: PropTypes.string,
  valueKey: PropTypes.string,
  label: PropTypes.string,
}

export default Group
